// Exports
export * from './LeadDetailsMaster';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/routes/sales/Lead/Details/index.tsx